<template>
    <div class="year-to-date-preview">
        <loader v-if="performance == null"/>
        <template v-if="performance !== null">
        <v-simple-table dense  class="account-table">
            <template v-slot:default>
                <thead>
                <tr>
                    <th>
                        Market Value <br> {{ performance.endDate }}
                    </th>
                    <th>
                        {{ performance.beginDate }}
                        <br>to {{ performance.endDate }}
                    </th>
                    <th>
                        MTD to {{ performance.endDate }}
                    </th>
                    <th>
                        QTD to {{ performance.endDate }}
                    </th>
                    <th>
                        YTD to {{ performance.endDate }}
                    </th>
                    <th>
                        Inception (Annualized)
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr v-if="performance.householdPerformance !== null" class="gray-line">
                        <td style="font-size: 16px !important;">{{ performance.sum | money }}</td>
                        <template v-for="(key, keyIndex) in performance.householdPerformance.performances">
                            <td :key="keyIndex" style="font-size: 16px !important;">{{ key | percentage }}</td>
                        </template>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
<!--        <year-to-date-high-charts-->
<!--            v-if="performance"-->
<!--            :performance="performance"-->
<!--            style="margin-bottom: 0px !important;"/>-->
        <router-link
            to="/year-to-date-performance"
            style="float: right;">See more details</router-link>
        </template>

    </div>
</template>

<style lang="scss">
    .year-to-date-preview th {
        height: 60px !important;
        color: #FFF !important;
        text-transform: uppercase;
        font-weight: 500;
        background-color: #1D5BE5;
    }

    .account-table td {
        padding: 10px !important;
        font-size: 16px !important;
        font-weight: 500;
    }

    .gray-line {
        background-color: #dbdbdb;
    }

</style>

<script>
import {mapState} from 'vuex';
import Loader from "@/components/Loader";
export default {
    components: {Loader},

    props: {
        performance: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),
    }
}
</script>

<style>
.account-table th {
    font-size: 0.875rem !important;
    font-weight: 500 !important;
}
</style>
